export default __webpack_public_path__ + "static/media/beneficios.3db80b50.svg";